import React from 'react';

import {
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { signIn } from '../thunk';

import TextFieldComp from '@/components/TextFieldComp';
import { userSlice } from '@/domain/user/redux';
import { Email } from '@/domain/user/service/entity/valueObjects/email';
import { Password } from '@/domain/user/service/entity/valueObjects/password';
import { UserId } from '@/domain/user/service/entity/valueObjects/userId';

const SignIn: React.FC = () => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<{
    username: string;
    password: string;
  }>({
    defaultValues: {
      username: '',
      password: '',
    },
  });
  const onSubmit = (condition: {
    username: string;
    password: string;
  }) => {
    dispatch(signIn(condition));
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <h2 style={{ textAlign: 'center' }}>
        ログイン
      </h2>
      <TextFieldComp
        type="text"
        control={control}
        name="username"
        label={`${UserId.label}/${Email.label}`}
        placeholder={`${UserId.placeholder}/${Email.placeholder}`}
        rules={{
          required: '必須項目です',
        }}
        errors={errors}
      />
      <TextFieldComp
        type={Password.type}
        control={control}
        rules={Password.validationRule}
        name={Password.key}
        label={Password.label}
        placeholder=""
        errors={errors}
      />
      <div style={{ textAlign: 'center', fontSize: '0.8em' }}>
        ユーザーIDとパスワードを入力してログインボタンを押してください。
      </div>
      <div style={{ textAlign: 'center', margin: '10px 0' }}>
        <Button
          size="large"
          type="submit"
          variant="contained"
          color="primary"
        >
          ログイン
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button size="small" onClick={() => dispatch(userSlice.actions.setMode('forgotpassword'))}>
          パスワードを忘れた方はこちら
        </Button>
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button size="small" onClick={() => dispatch(userSlice.actions.setMode('signup'))}>
          新規登録はこちら
        </Button>
      </div>
    </form>
  );
};

export default SignIn;
